module.exports = __webpack_public_path__ + "resources/img/img_global_network_en.8b88da96a6da4b368b485ad08f26b489.png";